/*
 * producer (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { producers } from "./producer.schema"

/* Select */
export type Producer = z.infer<typeof selectProducerSchema>
export const selectProducerSchema = createSelectSchema(producers)

/* Filters */
export type ProducerFilters = z.infer<typeof producerFiltersSchema>
export const producerFiltersSchema = z.object({
	id: z.string().optional(),
	name: z.string().optional(),
	showInDropdown: z.boolean().optional(),
	partnership: z.boolean().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createProducerSchema = createInsertSchema(producers).partial(globalCreateExclude)
export type CreateProducer = z.infer<typeof createProducerSchema>

/* Update */
export const updateProducerSchema = createInsertSchema(producers)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateProducer = z.infer<typeof updateProducerSchema>
